import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import Caption from '@/components/ui/Typo/Caption'
import Description from '@/components/ui/Typo/Description'
import H2 from '@/components/ui/Typo/H2'
import Subtitle from '@/components/ui/Typo/Subtitle'
import { IconCheckListBlack, IconNewHosting } from '@/res/icons'
import { NAMESPACE_HOSTING } from '@/res/namespaces'

const CmsSection = () => {
  const { t } = useTranslation(NAMESPACE_HOSTING)
  const items = [
    {
      text: 'WordPress',
    },
    {
      text: '1С-⁠Битрикс',
    },
    {
      text: 'Joomla',
    },
  ]

  const items2 = [
    {
      text: 'PHP 5.1–8.1.9',
    },
    {
      text: 'Python 2.7–3.10',
    },
    {
      Icon: IconCheckListBlack,
      text: 'Perl 5.16',
    },
  ]

  return (
    <div className="container mt-16 mb-20">
      <H2 uppercase={false} weight="font-semibold" color="text-primary">
        {t('cms_title')}
      </H2>

      <Subtitle weight="font-semibold" color="text-gray3" className="my-3">
        {t('cms_framework')}
      </Subtitle>
      <div className="grid items-start desktop:gap-5 gap-3 tablet:grid-cols-3 small:grid-cols-2 grid-cols-1">
        <div className="tablet:px-8 tablet:pt-6 px-4 pt-2 border-2 rounded-2xl">
          <Subtitle weight="font-semibold" color="text-primary">
            {t('ideal_for_wordpress')}
          </Subtitle>
          <Caption className="py-4">{t('install_wordpress')}</Caption>
          <IconNewHosting className="small:w-full w-[220px] mx-auto" />
        </div>
        <div className="tablet:px-5 tablet:pt-6 px-4 pt-2">
          <Subtitle weight="font-semibold" color="text-primary">
            {t('cms_support')}
          </Subtitle>
          <div>
            {items.map(({ text }, i) => (
              <TextRow text={text} key={i} />
            ))}
          </div>
        </div>
        <div className="tablet:px-5 tablet:pt-6 px-4 pt-2">
          <Subtitle weight="font-semibold" color="text-primary">
            {t('support_lang_fram')}
          </Subtitle>
          <div>
            {items2.map(({ text }, i) => (
              <TextRow text={text} key={i} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

interface ITextRow {
  text: string
}

const TextRow: React.FC<ITextRow> = ({ text }) => {
  return (
    <div className="flex my-4 items-start ">
      <IconCheckListBlack className="mr-4 flex-none fill-[#5f6368]" />
      <Description color="text-gray3">{text}</Description>
    </div>
  )
}

export default CmsSection
